import script from "./holiday-opening-hours.vue?vue&type=script&setup=true&lang=js"
export * from "./holiday-opening-hours.vue?vue&type=script&setup=true&lang=js"

import "./holiday-opening-hours.vue?vue&type=style&index=0&id=7d860524&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d860524"]])

export default __exports__